module.exports = "/images/vendor/flag-icon-css/flags/1x1/la.svg?6b86f25a0d2d8d95ffc5ebd33c393e14";